import { css } from '@emotion/react'

export const borderRadiusRound = css({
  borderRadius: '50%',
})
